/**
 * IsMapShowing
 *
 * Module that returns if the map is currently being shown
 *
 * @return {boolean}
 */

OT.createNS('OT.Search.Helpers.isMapShowing');

OT.Search.Helpers.isMapShowing = function() {

    return OT.Search.Params.get('ShowMap') === 'true' || OT.Search.Params.get('ShowMap') === true;

};